/* eslint-disable */
// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptAcceptSocialMediaRewardRequestData, AcceptAcceptSocialMediaRewardRequestErrors, AcceptAcceptSocialMediaRewardRequestResponses, AcceptDailyBonusData, AcceptDailyBonusErrors, AcceptDailyBonusResponses, AcceptFreeGoldCoinsData, AcceptFreeGoldCoinsErrors, AcceptFreeGoldCoinsResponses, AcceptInvitationBonusData, AcceptInvitationBonusErrors, AcceptInvitationBonusResponses, AcceptManualBonusData, AcceptManualBonusErrors, AcceptManualBonusResponses, AcceptPersonalJackpotData, AcceptPersonalJackpotErrors, AcceptPersonalJackpotResponses, AcceptRulesData, AcceptRulesErrors, AcceptRulesResponses, AcceptSweepstakeIntroData, AcceptSweepstakeIntroErrors, AcceptSweepstakeIntroResponses, ActivateAccountFreeSpinData, ActivateAccountFreeSpinErrors, ActivateAccountFreeSpinResponses, AddAccountFavouriteGameData, AddAccountFavouriteGameErrors, AddAccountFavouriteGameResponses, AssignInitialMissionData, AssignInitialMissionErrors, AssignInitialMissionResponses, AuthInfoData, AuthInfoErrors, AuthInfoResponses, BulkUpdateAccountNotificationStatusData, BulkUpdateAccountNotificationStatusErrors, BulkUpdateAccountNotificationStatusResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ChangeSubscriptionPreferencesData, ChangeSubscriptionPreferencesErrors, ChangeSubscriptionPreferencesResponses, CheckEmailExistsData, CheckEmailExistsErrors, CheckEmailExistsResponses, CheckLocationStatusData, CheckLocationStatusErrors, CheckLocationStatusResponses, CheckPasswordData, CheckPasswordErrors, CheckPasswordResponses, CheckRafBigWinData, CheckRafBigWinErrors, CheckRafBigWinResponses, ClaimMissionFreeSpinRewardsData, ClaimMissionFreeSpinRewardsErrors, ClaimMissionFreeSpinRewardsResponses, CloseAccountData, CloseAccountErrors, CloseAccountResponses, CompleteMiniGameRewardData, CompleteMiniGameRewardErrors, CompleteMiniGameRewardResponses, CreateAccountSessionLimitData, CreateAccountSessionLimitErrors, CreateAccountSessionLimitResponses, CreateAccountSessionRestrictionData, CreateAccountSessionRestrictionErrors, CreateAccountSessionRestrictionResponses, CreatePostalCodeData, CreatePostalCodeErrors, CreatePostalCodeResponses, DeleteAccountData, DeleteAccountErrors, DeleteAccountResponses, DeleteActiveAccountSessionLimitData, DeleteActiveAccountSessionLimitErrors, DeleteActiveAccountSessionLimitResponses, GameEventData, GameEventErrors, GameEventResponses, GetAccountBonusesData, GetAccountBonusesErrors, GetAccountBonusesResponses, GetAccountCrossBrandSignUpUrlsData, GetAccountCrossBrandSignUpUrlsErrors, GetAccountCrossBrandSignUpUrlsResponses, GetAccountFreeSpinsData, GetAccountFreeSpinsErrors, GetAccountFreeSpinsResponses, GetAccountInfoData, GetAccountInfoErrors, GetAccountInfoResponses, GetAccountInvitationsData, GetAccountInvitationsErrors, GetAccountInvitationsResponses, GetAccountJackpotInfoData, GetAccountJackpotInfoErrors, GetAccountJackpotInfoResponses, GetAccountLocationsRequestData, GetAccountLocationsRequestErrors, GetAccountLocationsRequestResponses, GetAccountMetaData, GetAccountMetaErrors, GetAccountMetaResponses, GetAccountNotificationsData, GetAccountNotificationsErrors, GetAccountNotificationsResponses, GetAccountPopupsData, GetAccountPopupsErrors, GetAccountPopupsResponses, GetAccountPromotionsData, GetAccountPromotionsErrors, GetAccountPromotionsResponses, GetAccountReferrerData, GetAccountReferrerErrors, GetAccountReferrerResponses, GetAccountSessionLimitsData, GetAccountSessionLimitsErrors, GetAccountSessionLimitsResponses, GetAccountSessionRestrictionsData, GetAccountSessionRestrictionsErrors, GetAccountSessionRestrictionsResponses, GetAccountSessionsData, GetAccountSessionsErrors, GetAccountSessionsResponses, GetAccountSettingsData, GetAccountSettingsErrors, GetAccountSettingsResponses, GetAccountTransactionHistoryData, GetAccountTransactionHistoryErrors, GetAccountTransactionHistoryResponses, GetBannersData, GetBannersErrors, GetBannersResponses, GetBrandFeaturesData, GetBrandFeaturesErrors, GetBrandFeaturesResponses, GetCurrencyAvailabilityRequestData, GetCurrencyAvailabilityRequestErrors, GetCurrencyAvailabilityRequestResponses, GetFeaturesData, GetFeaturesErrors, GetFeaturesResponses, GetFreeGoldCoinsStatusData, GetFreeGoldCoinsStatusErrors, GetFreeGoldCoinsStatusResponses, GetHomepageFeaturesData, GetHomepageFeaturesErrors, GetHomepageFeaturesResponses, GetJackpotInfoData, GetJackpotInfoErrors, GetJackpotInfoResponses, GetJackpotOptInData, GetJackpotOptInErrors, GetJackpotOptInResponses, GetJackpotTotalsData, GetJackpotTotalsErrors, GetJackpotTotalsResponses, GetLotteryResultsData, GetLotteryResultsErrors, GetLotteryResultsResponses, GetMiniGameRewardsData, GetMiniGameRewardsErrors, GetMiniGameRewardsResponses, GetMiniGameThemesData, GetMiniGameThemesErrors, GetMiniGameThemesResponses, GetPersonalJackpotData, GetPersonalJackpotErrors, GetPersonalJackpotResponses, GetRandomRewardInstancesData, GetRandomRewardInstancesErrors, GetRandomRewardInstancesResponses, GetRegistrationOperationPolicyData, GetRegistrationOperationPolicyErrors, GetRegistrationOperationPolicyResponses, GetRewardTemplateData, GetRewardTemplateErrors, GetRewardTemplateResponses, GetRewardTemplatesData, GetRewardTemplatesErrors, GetRewardTemplatesResponses, GetSignupCountriesAndStatesData, GetSignupCountriesAndStatesErrors, GetSignupCountriesAndStatesResponses, GetSignupCountriesData, GetSignupCountriesErrors, GetSignupCountriesResponses, GetTemporaryTokenData, GetTemporaryTokenErrors, GetTemporaryTokenResponses, GetVisitedPromotionsData, GetVisitedPromotionsErrors, GetVisitedPromotionsResponses, GpsUserEventData, GpsUserEventErrors, GpsUserEventResponses, Jackpots1Data, Jackpots1Errors, Jackpots1Responses, JackpotsData, JackpotsErrors, JackpotsResponses, LaunchBySupplierData, LaunchBySupplierErrors, LaunchBySupplierResponses, LaunchData, LaunchErrors, LaunchResponses, LinkAppleData, LinkAppleErrors, LinkAppleResponses, LinkExternalAccountData, LinkExternalAccountErrors, LinkExternalAccountResponses, LinkFacebookData, LinkFacebookErrors, LinkFacebookResponses, LinkGoogleData, LinkGoogleErrors, LinkGoogleResponses, ListMissionsData, ListMissionsErrors, ListMissionsResponses, LowOnCoinsData, LowOnCoinsErrors, LowOnCoinsResponses, MissionStepUpdateRequest1Data, MissionStepUpdateRequest1Errors, MissionStepUpdateRequest1Responses, MissionStepUpdateRequestData, MissionStepUpdateRequestErrors, MissionStepUpdateRequestResponses, OptInPromoData, OptInPromoErrors, OptInPromoResponses, OptOutArbitrationData, OptOutArbitrationErrors, OptOutArbitrationResponses, ProcessDynamoLinkData, ProcessDynamoLinkErrors, ProcessDynamoLinkResponses, ProcessDynamoPropertiesData, ProcessDynamoPropertiesErrors, ProcessDynamoPropertiesResponses, RegisterHomepageIconClickData, RegisterHomepageIconClickErrors, RegisterHomepageIconClickResponses, RemoveAccountFavouriteGameData, RemoveAccountFavouriteGameErrors, RemoveAccountFavouriteGameResponses, ResendEmailVerificationData, ResendEmailVerificationErrors, ResendEmailVerificationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordManuallyData, ResetPasswordManuallyErrors, ResetPasswordManuallyResponses, ResetPasswordResponses, RevealPostalCodeData, RevealPostalCodeErrors, RevealPostalCodeResponses, SaveJackpotOptInData, SaveJackpotOptInErrors, SaveJackpotOptInResponses, SendNudgeData, SendNudgeErrors, SendNudgeResponses, SendSignInByTokenEmailData, SendSignInByTokenEmailErrors, SendSignInByTokenEmailResponses, SendWelcomeEmailData, SendWelcomeEmailErrors, SendWelcomeEmailResponses, SetAccountAttributionInfoData, SetAccountAttributionInfoErrors, SetAccountAttributionInfoResponses, SetAccountCommunicationPreferencesData, SetAccountCommunicationPreferencesErrors, SetAccountCommunicationPreferencesResponses, SetAccountInfoData, SetAccountInfoErrors, SetAccountInfoResponses, SetAccountMarketingInfoData, SetAccountMarketingInfoErrors, SetAccountMarketingInfoResponses, SetAccountModeData, SetAccountModeErrors, SetAccountModeResponses, SetAccountOnboardedFlagData, SetAccountOnboardedFlagErrors, SetAccountOnboardedFlagResponses, SetLocationInfoData, SetLocationInfoErrors, SetLocationInfoResponses, SetNicknameData, SetNicknameErrors, SetNicknameResponses, SetPasswordData, SetPasswordErrors, SetPasswordResponses, SetPushInfoData, SetPushInfoErrors, SetPushInfoResponses, SetVisitorMetaInfoData, SetVisitorMetaInfoErrors, SetVisitorMetaInfoResponses, SignInAppleData, SignInAppleErrors, SignInAppleResponses, SignInByTokenData, SignInByTokenErrors, SignInByTokenResponses, SignInFacebookData, SignInFacebookErrors, SignInFacebookResponses, SignInGoogleData, SignInGoogleErrors, SignInGoogleResponses, SignInManualData, SignInManualErrors, SignInManualResponses, SignInPermanentData, SignInPermanentErrors, SignInPermanentResponses, SignOutData, SignOutErrors, SignOutResponses, SignUpAppleData, SignUpAppleErrors, SignUpAppleResponses, SignUpCrossBrandData, SignUpCrossBrandErrors, SignUpCrossBrandResponses, SignUpCrossBrandValidateData, SignUpCrossBrandValidateErrors, SignUpCrossBrandValidateResponses, SignUpFacebookData, SignUpFacebookErrors, SignUpFacebookResponses, SignUpGoogleData, SignUpGoogleErrors, SignUpGoogleResponses, SignUpGuestData, SignUpGuestErrors, SignUpGuestResponses, SignUpManualData, SignUpManualErrors, SignUpManualResponses, SpinWheelOfWinnersData, SpinWheelOfWinnersErrors, SpinWheelOfWinnersResponses, TrackAccountPopupsData, TrackAccountPopupsErrors, TrackAccountPopupsResponses, TrackAccountPromotionsData, TrackAccountPromotionsErrors, TrackAccountPromotionsResponses, UpdateAccountNotificationStatusData, UpdateAccountNotificationStatusErrors, UpdateAccountNotificationStatusResponses, UpdateAccountSessionLimitData, UpdateAccountSessionLimitErrors, UpdateAccountSessionLimitResponses, UpdateLocationStatusData, UpdateLocationStatusErrors, UpdateLocationStatusResponses, UpdateVisitedPromotionsData, UpdateVisitedPromotionsErrors, UpdateVisitedPromotionsResponses, WinnersData, WinnersErrors, WinnersResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const authInfo = <ThrowOnError extends boolean = false>(options: Options<AuthInfoData, ThrowOnError>) => (options.client ?? client).post<AuthInfoResponses, AuthInfoErrors, ThrowOnError>({
    url: '/v1/auth-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountCrossBrandSignUpUrls = <ThrowOnError extends boolean = false>(options: Options<GetAccountCrossBrandSignUpUrlsData, ThrowOnError>) => (options.client ?? client).post<GetAccountCrossBrandSignUpUrlsResponses, GetAccountCrossBrandSignUpUrlsErrors, ThrowOnError>({
    url: '/v1/sign_up/cross_brand/urls',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

export const linkApple = <ThrowOnError extends boolean = false>(options: Options<LinkAppleData, ThrowOnError>) => (options.client ?? client).post<LinkAppleResponses, LinkAppleErrors, ThrowOnError>({
    url: '/v1/link-social/apple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkFacebook = <ThrowOnError extends boolean = false>(options: Options<LinkFacebookData, ThrowOnError>) => (options.client ?? client).post<LinkFacebookResponses, LinkFacebookErrors, ThrowOnError>({
    url: '/v1/link-social/facebook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkGoogle = <ThrowOnError extends boolean = false>(options: Options<LinkGoogleData, ThrowOnError>) => (options.client ?? client).post<LinkGoogleResponses, LinkGoogleErrors, ThrowOnError>({
    url: '/v1/link-social/google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signInApple = <ThrowOnError extends boolean = false>(options: Options<SignInAppleData, ThrowOnError>) => (options.client ?? client).post<SignInAppleResponses, SignInAppleErrors, ThrowOnError>({
    url: '/v1/sign_in/apple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signInByToken = <ThrowOnError extends boolean = false>(options: Options<SignInByTokenData, ThrowOnError>) => (options.client ?? client).get<SignInByTokenResponses, SignInByTokenErrors, ThrowOnError>({ url: '/v1/sign_in/token', ...options });

export const signInFacebook = <ThrowOnError extends boolean = false>(options: Options<SignInFacebookData, ThrowOnError>) => (options.client ?? client).post<SignInFacebookResponses, SignInFacebookErrors, ThrowOnError>({
    url: '/v1/sign_in/facebook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signInGoogle = <ThrowOnError extends boolean = false>(options: Options<SignInGoogleData, ThrowOnError>) => (options.client ?? client).post<SignInGoogleResponses, SignInGoogleErrors, ThrowOnError>({
    url: '/v1/sign_in/google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signInManual = <ThrowOnError extends boolean = false>(options: Options<SignInManualData, ThrowOnError>) => (options.client ?? client).post<SignInManualResponses, SignInManualErrors, ThrowOnError>({
    url: '/v1/sign_in/manual',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signInPermanent = <ThrowOnError extends boolean = false>(options: Options<SignInPermanentData, ThrowOnError>) => (options.client ?? client).post<SignInPermanentResponses, SignInPermanentErrors, ThrowOnError>({
    url: '/v1/sign_in/permanent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signOut = <ThrowOnError extends boolean = false>(options: Options<SignOutData, ThrowOnError>) => (options.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({
    url: '/v1/sign_out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signUpApple = <ThrowOnError extends boolean = false>(options: Options<SignUpAppleData, ThrowOnError>) => (options.client ?? client).post<SignUpAppleResponses, SignUpAppleErrors, ThrowOnError>({
    url: '/v1/sign_up/apple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signUpCrossBrand = <ThrowOnError extends boolean = false>(options: Options<SignUpCrossBrandData, ThrowOnError>) => (options.client ?? client).post<SignUpCrossBrandResponses, SignUpCrossBrandErrors, ThrowOnError>({
    url: '/v1/sign_up/cross_brand',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signUpCrossBrandValidate = <ThrowOnError extends boolean = false>(options: Options<SignUpCrossBrandValidateData, ThrowOnError>) => (options.client ?? client).post<SignUpCrossBrandValidateResponses, SignUpCrossBrandValidateErrors, ThrowOnError>({
    url: '/v1/sign_up/cross_brand/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signUpFacebook = <ThrowOnError extends boolean = false>(options: Options<SignUpFacebookData, ThrowOnError>) => (options.client ?? client).post<SignUpFacebookResponses, SignUpFacebookErrors, ThrowOnError>({
    url: '/v1/sign_up/facebook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signUpGoogle = <ThrowOnError extends boolean = false>(options: Options<SignUpGoogleData, ThrowOnError>) => (options.client ?? client).post<SignUpGoogleResponses, SignUpGoogleErrors, ThrowOnError>({
    url: '/v1/sign_up/google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signUpGuest = <ThrowOnError extends boolean = false>(options: Options<SignUpGuestData, ThrowOnError>) => (options.client ?? client).post<SignUpGuestResponses, SignUpGuestErrors, ThrowOnError>({
    url: '/v1/sign_up/guest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const signUpManual = <ThrowOnError extends boolean = false>(options: Options<SignUpManualData, ThrowOnError>) => (options.client ?? client).post<SignUpManualResponses, SignUpManualErrors, ThrowOnError>({
    url: '/v1/sign_up/manual',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const checkEmailExists = <ThrowOnError extends boolean = false>(options: Options<CheckEmailExistsData, ThrowOnError>) => (options.client ?? client).post<CheckEmailExistsResponses, CheckEmailExistsErrors, ThrowOnError>({
    url: '/v1/check-email-exists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>) => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/v1/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkExternalAccount = <ThrowOnError extends boolean = false>(options: Options<LinkExternalAccountData, ThrowOnError>) => (options.client ?? client).post<LinkExternalAccountResponses, LinkExternalAccountErrors, ThrowOnError>({
    url: '/v1/account/link-external',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

export const acceptAcceptSocialMediaRewardRequest = <ThrowOnError extends boolean = false>(options: Options<AcceptAcceptSocialMediaRewardRequestData, ThrowOnError>) => (options.client ?? client).post<AcceptAcceptSocialMediaRewardRequestResponses, AcceptAcceptSocialMediaRewardRequestErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptSocialMediaRewardRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const acceptDailyBonus = <ThrowOnError extends boolean = false>(options: Options<AcceptDailyBonusData, ThrowOnError>) => (options.client ?? client).post<AcceptDailyBonusResponses, AcceptDailyBonusErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptDailyBonusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const acceptFreeGoldCoins = <ThrowOnError extends boolean = false>(options: Options<AcceptFreeGoldCoinsData, ThrowOnError>) => (options.client ?? client).post<AcceptFreeGoldCoinsResponses, AcceptFreeGoldCoinsErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptFreeGoldCoinsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const acceptInvitationBonus = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationBonusData, ThrowOnError>) => (options.client ?? client).post<AcceptInvitationBonusResponses, AcceptInvitationBonusErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptInvitationBonusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const acceptManualBonus = <ThrowOnError extends boolean = false>(options: Options<AcceptManualBonusData, ThrowOnError>) => (options.client ?? client).post<AcceptManualBonusResponses, AcceptManualBonusErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptManualBonusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const acceptRules = <ThrowOnError extends boolean = false>(options: Options<AcceptRulesData, ThrowOnError>) => (options.client ?? client).post<AcceptRulesResponses, AcceptRulesErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptRulesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const acceptSweepstakeIntro = <ThrowOnError extends boolean = false>(options: Options<AcceptSweepstakeIntroData, ThrowOnError>) => (options.client ?? client).post<AcceptSweepstakeIntroResponses, AcceptSweepstakeIntroErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptSweepstakeIntroRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const addAccountFavouriteGame = <ThrowOnError extends boolean = false>(options: Options<AddAccountFavouriteGameData, ThrowOnError>) => (options.client ?? client).post<AddAccountFavouriteGameResponses, AddAccountFavouriteGameErrors, ThrowOnError>({
    url: '/v2/dispatch/AddAccountFavouriteGameRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>) => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    url: '/v2/dispatch/ChangePasswordRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const changeSubscriptionPreferences = <ThrowOnError extends boolean = false>(options: Options<ChangeSubscriptionPreferencesData, ThrowOnError>) => (options.client ?? client).post<ChangeSubscriptionPreferencesResponses, ChangeSubscriptionPreferencesErrors, ThrowOnError>({
    url: '/v2/dispatch/ChangeSubscriptionPreferencesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const checkLocationStatus = <ThrowOnError extends boolean = false>(options: Options<CheckLocationStatusData, ThrowOnError>) => (options.client ?? client).post<CheckLocationStatusResponses, CheckLocationStatusErrors, ThrowOnError>({
    url: '/v2/dispatch/CheckLocationStatusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const checkPassword = <ThrowOnError extends boolean = false>(options: Options<CheckPasswordData, ThrowOnError>) => (options.client ?? client).post<CheckPasswordResponses, CheckPasswordErrors, ThrowOnError>({
    url: '/v2/dispatch/CheckPasswordRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const checkRafBigWin = <ThrowOnError extends boolean = false>(options: Options<CheckRafBigWinData, ThrowOnError>) => (options.client ?? client).post<CheckRafBigWinResponses, CheckRafBigWinErrors, ThrowOnError>({
    url: '/v2/dispatch/CheckRafBigWinRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const closeAccount = <ThrowOnError extends boolean = false>(options: Options<CloseAccountData, ThrowOnError>) => (options.client ?? client).post<CloseAccountResponses, CloseAccountErrors, ThrowOnError>({
    url: '/v2/dispatch/AccountClosureRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createAccountSessionLimit = <ThrowOnError extends boolean = false>(options: Options<CreateAccountSessionLimitData, ThrowOnError>) => (options.client ?? client).post<CreateAccountSessionLimitResponses, CreateAccountSessionLimitErrors, ThrowOnError>({
    url: '/v2/dispatch/CreateAccountSessionLimitRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createAccountSessionRestriction = <ThrowOnError extends boolean = false>(options: Options<CreateAccountSessionRestrictionData, ThrowOnError>) => (options.client ?? client).post<CreateAccountSessionRestrictionResponses, CreateAccountSessionRestrictionErrors, ThrowOnError>({
    url: '/v2/dispatch/CreateAccountSessionRestrictionRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createPostalCode = <ThrowOnError extends boolean = false>(options: Options<CreatePostalCodeData, ThrowOnError>) => (options.client ?? client).post<CreatePostalCodeResponses, CreatePostalCodeErrors, ThrowOnError>({
    url: '/v2/dispatch/CreatePostalCodeRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteActiveAccountSessionLimit = <ThrowOnError extends boolean = false>(options: Options<DeleteActiveAccountSessionLimitData, ThrowOnError>) => (options.client ?? client).post<DeleteActiveAccountSessionLimitResponses, DeleteActiveAccountSessionLimitErrors, ThrowOnError>({
    url: '/v2/dispatch/DeleteActiveAccountSessionLimitRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountBonuses = <ThrowOnError extends boolean = false>(options: Options<GetAccountBonusesData, ThrowOnError>) => (options.client ?? client).post<GetAccountBonusesResponses, GetAccountBonusesErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountBonusesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountInfo = <ThrowOnError extends boolean = false>(options: Options<GetAccountInfoData, ThrowOnError>) => (options.client ?? client).post<GetAccountInfoResponses, GetAccountInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountInvitations = <ThrowOnError extends boolean = false>(options: Options<GetAccountInvitationsData, ThrowOnError>) => (options.client ?? client).post<GetAccountInvitationsResponses, GetAccountInvitationsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountInvitationsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountLocationsRequest = <ThrowOnError extends boolean = false>(options: Options<GetAccountLocationsRequestData, ThrowOnError>) => (options.client ?? client).post<GetAccountLocationsRequestResponses, GetAccountLocationsRequestErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountLocationsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountMeta = <ThrowOnError extends boolean = false>(options: Options<GetAccountMetaData, ThrowOnError>) => (options.client ?? client).post<GetAccountMetaResponses, GetAccountMetaErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountMetaRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountReferrer = <ThrowOnError extends boolean = false>(options: Options<GetAccountReferrerData, ThrowOnError>) => (options.client ?? client).post<GetAccountReferrerResponses, GetAccountReferrerErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountRefererInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountSessionLimits = <ThrowOnError extends boolean = false>(options: Options<GetAccountSessionLimitsData, ThrowOnError>) => (options.client ?? client).post<GetAccountSessionLimitsResponses, GetAccountSessionLimitsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountSessionLimitsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountSessionRestrictions = <ThrowOnError extends boolean = false>(options: Options<GetAccountSessionRestrictionsData, ThrowOnError>) => (options.client ?? client).post<GetAccountSessionRestrictionsResponses, GetAccountSessionRestrictionsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountSessionRestrictionsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountSessions = <ThrowOnError extends boolean = false>(options: Options<GetAccountSessionsData, ThrowOnError>) => (options.client ?? client).post<GetAccountSessionsResponses, GetAccountSessionsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountSessionsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountSettings = <ThrowOnError extends boolean = false>(options: Options<GetAccountSettingsData, ThrowOnError>) => (options.client ?? client).post<GetAccountSettingsResponses, GetAccountSettingsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountSettingsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountTransactionHistory = <ThrowOnError extends boolean = false>(options: Options<GetAccountTransactionHistoryData, ThrowOnError>) => (options.client ?? client).post<GetAccountTransactionHistoryResponses, GetAccountTransactionHistoryErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountTransactionHistoryRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getBanners = <ThrowOnError extends boolean = false>(options: Options<GetBannersData, ThrowOnError>) => (options.client ?? client).post<GetBannersResponses, GetBannersErrors, ThrowOnError>({
    url: '/v2/dispatch/GetBannersRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getBrandFeatures = <ThrowOnError extends boolean = false>(options: Options<GetBrandFeaturesData, ThrowOnError>) => (options.client ?? client).post<GetBrandFeaturesResponses, GetBrandFeaturesErrors, ThrowOnError>({
    url: '/v2/dispatch/GetBrandFeaturesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getCurrencyAvailabilityRequest = <ThrowOnError extends boolean = false>(options: Options<GetCurrencyAvailabilityRequestData, ThrowOnError>) => (options.client ?? client).post<GetCurrencyAvailabilityRequestResponses, GetCurrencyAvailabilityRequestErrors, ThrowOnError>({
    url: '/v2/dispatch/GetCurrencyAvailabilityRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getFeatures = <ThrowOnError extends boolean = false>(options: Options<GetFeaturesData, ThrowOnError>) => (options.client ?? client).post<GetFeaturesResponses, GetFeaturesErrors, ThrowOnError>({
    url: '/v2/dispatch/GetFeaturesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getFreeGoldCoinsStatus = <ThrowOnError extends boolean = false>(options: Options<GetFreeGoldCoinsStatusData, ThrowOnError>) => (options.client ?? client).post<GetFreeGoldCoinsStatusResponses, GetFreeGoldCoinsStatusErrors, ThrowOnError>({
    url: '/v2/dispatch/GetFreeGoldCoinsStatusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getLotteryResults = <ThrowOnError extends boolean = false>(options: Options<GetLotteryResultsData, ThrowOnError>) => (options.client ?? client).post<GetLotteryResultsResponses, GetLotteryResultsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetLotteryResultsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getRegistrationOperationPolicy = <ThrowOnError extends boolean = false>(options: Options<GetRegistrationOperationPolicyData, ThrowOnError>) => (options.client ?? client).post<GetRegistrationOperationPolicyResponses, GetRegistrationOperationPolicyErrors, ThrowOnError>({
    url: '/v2/dispatch/GetRegistrationOperationPolicyRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSignupCountries = <ThrowOnError extends boolean = false>(options: Options<GetSignupCountriesData, ThrowOnError>) => (options.client ?? client).post<GetSignupCountriesResponses, GetSignupCountriesErrors, ThrowOnError>({
    url: '/v2/dispatch/GetSignupCountriesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSignupCountriesAndStates = <ThrowOnError extends boolean = false>(options: Options<GetSignupCountriesAndStatesData, ThrowOnError>) => (options.client ?? client).post<GetSignupCountriesAndStatesResponses, GetSignupCountriesAndStatesErrors, ThrowOnError>({
    url: '/v2/dispatch/GetSignupCountriesAndStatesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getTemporaryToken = <ThrowOnError extends boolean = false>(options: Options<GetTemporaryTokenData, ThrowOnError>) => (options.client ?? client).post<GetTemporaryTokenResponses, GetTemporaryTokenErrors, ThrowOnError>({
    url: '/v2/dispatch/GetTemporaryTokenRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getVisitedPromotions = <ThrowOnError extends boolean = false>(options: Options<GetVisitedPromotionsData, ThrowOnError>) => (options.client ?? client).post<GetVisitedPromotionsResponses, GetVisitedPromotionsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetVisitedPromotionsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const gpsUserEvent = <ThrowOnError extends boolean = false>(options: Options<GpsUserEventData, ThrowOnError>) => (options.client ?? client).post<GpsUserEventResponses, GpsUserEventErrors, ThrowOnError>({
    url: '/v2/dispatch/GpsUserEventRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const lowOnCoins = <ThrowOnError extends boolean = false>(options: Options<LowOnCoinsData, ThrowOnError>) => (options.client ?? client).post<LowOnCoinsResponses, LowOnCoinsErrors, ThrowOnError>({
    url: '/v2/dispatch/LowOnCoinsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const missionStepUpdateRequest = <ThrowOnError extends boolean = false>(options: Options<MissionStepUpdateRequestData, ThrowOnError>) => (options.client ?? client).post<MissionStepUpdateRequestResponses, MissionStepUpdateRequestErrors, ThrowOnError>({
    url: '/v2/dispatch/MissionStepUpdateRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const optInPromo = <ThrowOnError extends boolean = false>(options: Options<OptInPromoData, ThrowOnError>) => (options.client ?? client).post<OptInPromoResponses, OptInPromoErrors, ThrowOnError>({
    url: '/v2/dispatch/OptInPromoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const optOutArbitration = <ThrowOnError extends boolean = false>(options: Options<OptOutArbitrationData, ThrowOnError>) => (options.client ?? client).post<OptOutArbitrationResponses, OptOutArbitrationErrors, ThrowOnError>({
    url: '/v2/dispatch/OptOutArbitrationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const processDynamoLink = <ThrowOnError extends boolean = false>(options: Options<ProcessDynamoLinkData, ThrowOnError>) => (options.client ?? client).post<ProcessDynamoLinkResponses, ProcessDynamoLinkErrors, ThrowOnError>({
    url: '/v2/dispatch/ProcessDynamoLinkRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const processDynamoProperties = <ThrowOnError extends boolean = false>(options: Options<ProcessDynamoPropertiesData, ThrowOnError>) => (options.client ?? client).post<ProcessDynamoPropertiesResponses, ProcessDynamoPropertiesErrors, ThrowOnError>({
    url: '/v2/dispatch/ProcessDynamoPropertiesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeAccountFavouriteGame = <ThrowOnError extends boolean = false>(options: Options<RemoveAccountFavouriteGameData, ThrowOnError>) => (options.client ?? client).post<RemoveAccountFavouriteGameResponses, RemoveAccountFavouriteGameErrors, ThrowOnError>({
    url: '/v2/dispatch/RemoveAccountFavouriteGameRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resendEmailVerification = <ThrowOnError extends boolean = false>(options: Options<ResendEmailVerificationData, ThrowOnError>) => (options.client ?? client).post<ResendEmailVerificationResponses, ResendEmailVerificationErrors, ThrowOnError>({
    url: '/v2/dispatch/ResendEmailVerificationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resetPasswordManually = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordManuallyData, ThrowOnError>) => (options.client ?? client).post<ResetPasswordManuallyResponses, ResetPasswordManuallyErrors, ThrowOnError>({
    url: '/v2/dispatch/ResetPasswordManuallyRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const revealPostalCode = <ThrowOnError extends boolean = false>(options: Options<RevealPostalCodeData, ThrowOnError>) => (options.client ?? client).post<RevealPostalCodeResponses, RevealPostalCodeErrors, ThrowOnError>({
    url: '/v2/dispatch/RevealPostalCodeRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sendNudge = <ThrowOnError extends boolean = false>(options: Options<SendNudgeData, ThrowOnError>) => (options.client ?? client).post<SendNudgeResponses, SendNudgeErrors, ThrowOnError>({
    url: '/v2/dispatch/SendNudgeRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sendSignInByTokenEmail = <ThrowOnError extends boolean = false>(options: Options<SendSignInByTokenEmailData, ThrowOnError>) => (options.client ?? client).post<SendSignInByTokenEmailResponses, SendSignInByTokenEmailErrors, ThrowOnError>({
    url: '/v2/dispatch/SendSignInByTokenEmailRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sendWelcomeEmail = <ThrowOnError extends boolean = false>(options: Options<SendWelcomeEmailData, ThrowOnError>) => (options.client ?? client).post<SendWelcomeEmailResponses, SendWelcomeEmailErrors, ThrowOnError>({
    url: '/v2/dispatch/SendWelcomeEmailRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setAccountAttributionInfo = <ThrowOnError extends boolean = false>(options: Options<SetAccountAttributionInfoData, ThrowOnError>) => (options.client ?? client).post<SetAccountAttributionInfoResponses, SetAccountAttributionInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/SetAccountAttributionInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setAccountCommunicationPreferences = <ThrowOnError extends boolean = false>(options: Options<SetAccountCommunicationPreferencesData, ThrowOnError>) => (options.client ?? client).post<SetAccountCommunicationPreferencesResponses, SetAccountCommunicationPreferencesErrors, ThrowOnError>({
    url: '/v2/dispatch/SetAccountCommunicationPreferencesRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setAccountInfo = <ThrowOnError extends boolean = false>(options: Options<SetAccountInfoData, ThrowOnError>) => (options.client ?? client).post<SetAccountInfoResponses, SetAccountInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/SetAccountInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setAccountMarketingInfo = <ThrowOnError extends boolean = false>(options: Options<SetAccountMarketingInfoData, ThrowOnError>) => (options.client ?? client).post<SetAccountMarketingInfoResponses, SetAccountMarketingInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/SetAccountMarketingInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const setAccountMode = <ThrowOnError extends boolean = false>(options: Options<SetAccountModeData, ThrowOnError>) => (options.client ?? client).post<SetAccountModeResponses, SetAccountModeErrors, ThrowOnError>({
    url: '/v2/dispatch/SetAccountModeRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setAccountOnboardedFlag = <ThrowOnError extends boolean = false>(options: Options<SetAccountOnboardedFlagData, ThrowOnError>) => (options.client ?? client).post<SetAccountOnboardedFlagResponses, SetAccountOnboardedFlagErrors, ThrowOnError>({
    url: '/v2/dispatch/SetAccountOnboardedFlagRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setLocationInfo = <ThrowOnError extends boolean = false>(options: Options<SetLocationInfoData, ThrowOnError>) => (options.client ?? client).post<SetLocationInfoResponses, SetLocationInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/SetLocationInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setNickname = <ThrowOnError extends boolean = false>(options: Options<SetNicknameData, ThrowOnError>) => (options.client ?? client).post<SetNicknameResponses, SetNicknameErrors, ThrowOnError>({
    url: '/v2/dispatch/SetNicknameRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setPassword = <ThrowOnError extends boolean = false>(options: Options<SetPasswordData, ThrowOnError>) => (options.client ?? client).post<SetPasswordResponses, SetPasswordErrors, ThrowOnError>({
    url: '/v2/dispatch/SetPasswordRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setPushInfo = <ThrowOnError extends boolean = false>(options: Options<SetPushInfoData, ThrowOnError>) => (options.client ?? client).post<SetPushInfoResponses, SetPushInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/SetPushInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setVisitorMetaInfo = <ThrowOnError extends boolean = false>(options: Options<SetVisitorMetaInfoData, ThrowOnError>) => (options.client ?? client).post<SetVisitorMetaInfoResponses, SetVisitorMetaInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/SetVisitorMetaInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateAccountSessionLimit = <ThrowOnError extends boolean = false>(options: Options<UpdateAccountSessionLimitData, ThrowOnError>) => (options.client ?? client).post<UpdateAccountSessionLimitResponses, UpdateAccountSessionLimitErrors, ThrowOnError>({
    url: '/v2/dispatch/UpdateAccountSessionLimitRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update account location status with IP location and GPS coordinates
 */
export const updateLocationStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateLocationStatusData, ThrowOnError>) => (options.client ?? client).post<UpdateLocationStatusResponses, UpdateLocationStatusErrors, ThrowOnError>({
    url: '/v2/dispatch/UpdateLocationStatusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateVisitedPromotions = <ThrowOnError extends boolean = false>(options: Options<UpdateVisitedPromotionsData, ThrowOnError>) => (options.client ?? client).post<UpdateVisitedPromotionsResponses, UpdateVisitedPromotionsErrors, ThrowOnError>({
    url: '/v2/dispatch/UpdateVisitedPromotionsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountData, ThrowOnError>) => (options.client ?? client).post<DeleteAccountResponses, DeleteAccountErrors, ThrowOnError>({
    url: '/v1/account_delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getHomepageFeatures = <ThrowOnError extends boolean = false>(options: Options<GetHomepageFeaturesData, ThrowOnError>) => (options.client ?? client).post<GetHomepageFeaturesResponses, GetHomepageFeaturesErrors, ThrowOnError>({ url: '/v1/homepage/features', ...options });

export const registerHomepageIconClick = <ThrowOnError extends boolean = false>(options: Options<RegisterHomepageIconClickData, ThrowOnError>) => (options.client ?? client).post<RegisterHomepageIconClickResponses, RegisterHomepageIconClickErrors, ThrowOnError>({ url: '/v1/homepage/features/click-event', ...options });

export const acceptPersonalJackpot = <ThrowOnError extends boolean = false>(options: Options<AcceptPersonalJackpotData, ThrowOnError>) => (options.client ?? client).post<AcceptPersonalJackpotResponses, AcceptPersonalJackpotErrors, ThrowOnError>({
    url: '/v2/dispatch/AcceptPersonalJackpotRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountJackpotInfo = <ThrowOnError extends boolean = false>(options: Options<GetAccountJackpotInfoData, ThrowOnError>) => (options.client ?? client).post<GetAccountJackpotInfoResponses, GetAccountJackpotInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountJackpotInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getJackpotInfo = <ThrowOnError extends boolean = false>(options: Options<GetJackpotInfoData, ThrowOnError>) => (options.client ?? client).post<GetJackpotInfoResponses, GetJackpotInfoErrors, ThrowOnError>({
    url: '/v2/dispatch/GetJackpotInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const getJackpotOptIn = <ThrowOnError extends boolean = false>(options: Options<GetJackpotOptInData, ThrowOnError>) => (options.client ?? client).post<GetJackpotOptInResponses, GetJackpotOptInErrors, ThrowOnError>({
    url: '/v2/dispatch/GetJackpotOptInRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const getJackpotTotals = <ThrowOnError extends boolean = false>(options: Options<GetJackpotTotalsData, ThrowOnError>) => (options.client ?? client).post<GetJackpotTotalsResponses, GetJackpotTotalsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetJackpotTotalsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const getPersonalJackpot = <ThrowOnError extends boolean = false>(options: Options<GetPersonalJackpotData, ThrowOnError>) => (options.client ?? client).post<GetPersonalJackpotResponses, GetPersonalJackpotErrors, ThrowOnError>({
    url: '/v2/dispatch/GetPersonalJackpotRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const saveJackpotOptIn = <ThrowOnError extends boolean = false>(options: Options<SaveJackpotOptInData, ThrowOnError>) => (options.client ?? client).post<SaveJackpotOptInResponses, SaveJackpotOptInErrors, ThrowOnError>({
    url: '/v2/dispatch/SaveJackpotOptInRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const assignInitialMission = <ThrowOnError extends boolean = false>(options: Options<AssignInitialMissionData, ThrowOnError>) => (options.client ?? client).post<AssignInitialMissionResponses, AssignInitialMissionErrors, ThrowOnError>({
    url: '/v1/missions/initial-assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const missionStepUpdateRequest1 = <ThrowOnError extends boolean = false>(options: Options<MissionStepUpdateRequest1Data, ThrowOnError>) => (options.client ?? client).patch<MissionStepUpdateRequest1Responses, MissionStepUpdateRequest1Errors, ThrowOnError>({
    url: '/v1/missions/steps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const spinWheelOfWinners = <ThrowOnError extends boolean = false>(options: Options<SpinWheelOfWinnersData, ThrowOnError>) => (options.client ?? client).post<SpinWheelOfWinnersResponses, SpinWheelOfWinnersErrors, ThrowOnError>({
    url: '/v2/dispatch/SpinWheelOfWinnersRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const activateAccountFreeSpin = <ThrowOnError extends boolean = false>(options: Options<ActivateAccountFreeSpinData, ThrowOnError>) => (options.client ?? client).post<ActivateAccountFreeSpinResponses, ActivateAccountFreeSpinErrors, ThrowOnError>({
    url: '/v2/dispatch/ActivateAccountFreeSpinRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const gameEvent = <ThrowOnError extends boolean = false>(options: Options<GameEventData, ThrowOnError>) => (options.client ?? client).post<GameEventResponses, GameEventErrors, ThrowOnError>({
    url: '/v2/dispatch/GameEventRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountFreeSpins = <ThrowOnError extends boolean = false>(options: Options<GetAccountFreeSpinsData, ThrowOnError>) => (options.client ?? client).post<GetAccountFreeSpinsResponses, GetAccountFreeSpinsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountFreeSpinsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a list of jackpots
 */
export const jackpots = <ThrowOnError extends boolean = false>(options: Options<JackpotsData, ThrowOnError>) => (options.client ?? client).get<JackpotsResponses, JackpotsErrors, ThrowOnError>({ url: '/v1/jackpots/{brand}', ...options });

/**
 * Get a list of jackpots
 *
 * @deprecated
 */
export const jackpots1 = <ThrowOnError extends boolean = false>(options: Options<Jackpots1Data, ThrowOnError>) => (options.client ?? client).get<Jackpots1Responses, Jackpots1Errors, ThrowOnError>({ url: '/v1/jackpots/{operator}/{provider}', ...options });

/**
 * Get a list of jackpot winners
 */
export const winners = <ThrowOnError extends boolean = false>(options: Options<WinnersData, ThrowOnError>) => (options.client ?? client).get<WinnersResponses, WinnersErrors, ThrowOnError>({ url: '/v1/jackpots/winners/{operator}/{provider}', ...options });

/**
 * Get a URL to launch the game
 */
export const launch = <ThrowOnError extends boolean = false>(options: Options<LaunchData, ThrowOnError>) => (options.client ?? client).post<LaunchResponses, LaunchErrors, ThrowOnError>({
    url: '/v1/launch/{operator}/{provider}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a URL to launch the game
 */
export const launchBySupplier = <ThrowOnError extends boolean = false>(options: Options<LaunchBySupplierData, ThrowOnError>) => (options.client ?? client).post<LaunchBySupplierResponses, LaunchBySupplierErrors, ThrowOnError>({
    url: '/v1/launch/{operator}/suppliers/{supplier}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const claimMissionFreeSpinRewards = <ThrowOnError extends boolean = false>(options: Options<ClaimMissionFreeSpinRewardsData, ThrowOnError>) => (options.client ?? client).post<ClaimMissionFreeSpinRewardsResponses, ClaimMissionFreeSpinRewardsErrors, ThrowOnError>({
    url: '/v1/missions/rewards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMissions = <ThrowOnError extends boolean = false>(options: Options<ListMissionsData, ThrowOnError>) => (options.client ?? client).post<ListMissionsResponses, ListMissionsErrors, ThrowOnError>({
    url: '/v1/missions/list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete mini-game and take reward
 */
export const completeMiniGameReward = <ThrowOnError extends boolean = false>(options: Options<CompleteMiniGameRewardData, ThrowOnError>) => (options.client ?? client).post<CompleteMiniGameRewardResponses, CompleteMiniGameRewardErrors, ThrowOnError>({
    url: '/v1/CompleteMiniGameReward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get mini-game reward instances
 */
export const getMiniGameRewards = <ThrowOnError extends boolean = false>(options: Options<GetMiniGameRewardsData, ThrowOnError>) => (options.client ?? client).get<GetMiniGameRewardsResponses, GetMiniGameRewardsErrors, ThrowOnError>({ url: '/v1/GetMiniGameRewards', ...options });

/**
 * Get mini game rewards by theme
 */
export const getMiniGameThemes = <ThrowOnError extends boolean = false>(options: Options<GetMiniGameThemesData, ThrowOnError>) => (options.client ?? client).post<GetMiniGameThemesResponses, GetMiniGameThemesErrors, ThrowOnError>({
    url: '/v1/GetMiniGameThemes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get random reward instances by payment transaction ids
 */
export const getRandomRewardInstances = <ThrowOnError extends boolean = false>(options: Options<GetRandomRewardInstancesData, ThrowOnError>) => (options.client ?? client).post<GetRandomRewardInstancesResponses, GetRandomRewardInstancesErrors, ThrowOnError>({
    url: '/v1/GetRandomRewardInstances',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

/**
 * Get reward template by code
 */
export const getRewardTemplate = <ThrowOnError extends boolean = false>(options: Options<GetRewardTemplateData, ThrowOnError>) => (options.client ?? client).post<GetRewardTemplateResponses, GetRewardTemplateErrors, ThrowOnError>({
    url: '/v1/GetRewardTemplate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get reward templates by several codes
 */
export const getRewardTemplates = <ThrowOnError extends boolean = false>(options: Options<GetRewardTemplatesData, ThrowOnError>) => (options.client ?? client).post<GetRewardTemplatesResponses, GetRewardTemplatesErrors, ThrowOnError>({
    url: '/v1/GetRewardTemplates',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options.headers
    }
});

export const bulkUpdateAccountNotificationStatus = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateAccountNotificationStatusData, ThrowOnError>) => (options.client ?? client).post<BulkUpdateAccountNotificationStatusResponses, BulkUpdateAccountNotificationStatusErrors, ThrowOnError>({
    url: '/v2/dispatch/BulkUpdateAccountNotificationStatusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountNotifications = <ThrowOnError extends boolean = false>(options: Options<GetAccountNotificationsData, ThrowOnError>) => (options.client ?? client).post<GetAccountNotificationsResponses, GetAccountNotificationsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountNotificationsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountPopups = <ThrowOnError extends boolean = false>(options: Options<GetAccountPopupsData, ThrowOnError>) => (options.client ?? client).post<GetAccountPopupsResponses, GetAccountPopupsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountPopupsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountPromotions = <ThrowOnError extends boolean = false>(options: Options<GetAccountPromotionsData, ThrowOnError>) => (options.client ?? client).post<GetAccountPromotionsResponses, GetAccountPromotionsErrors, ThrowOnError>({
    url: '/v2/dispatch/GetAccountPromotionsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const trackAccountPopups = <ThrowOnError extends boolean = false>(options: Options<TrackAccountPopupsData, ThrowOnError>) => (options.client ?? client).post<TrackAccountPopupsResponses, TrackAccountPopupsErrors, ThrowOnError>({
    url: '/v2/dispatch/TrackAccountPopupsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const trackAccountPromotions = <ThrowOnError extends boolean = false>(options: Options<TrackAccountPromotionsData, ThrowOnError>) => (options.client ?? client).post<TrackAccountPromotionsResponses, TrackAccountPromotionsErrors, ThrowOnError>({
    url: '/v2/dispatch/TrackAccountPromotionsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateAccountNotificationStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateAccountNotificationStatusData, ThrowOnError>) => (options.client ?? client).post<UpdateAccountNotificationStatusResponses, UpdateAccountNotificationStatusErrors, ThrowOnError>({
    url: '/v2/dispatch/UpdateAccountNotificationStatusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
